import { CONNECT_STEP, STEPS, type WizardStep } from './constants';

// The steps a host actually renders. Ids stay those of STEPS, so skipping a
// step never renumbers the schema/draft mappings keyed by id.
export function visibleSteps(hasConnectStep: boolean): WizardStep[] {
  if (hasConnectStep) return STEPS;
  return STEPS.filter((step) => step.num !== CONNECT_STEP);
}

function stepIndex(steps: WizardStep[], stepId: number): number {
  return steps.findIndex((step) => step.num === stepId);
}

// 1-based position of a step among the visible ones — what the stepper and
// "Step N of M" show.
export function stepPosition(steps: WizardStep[], stepId: number): number {
  return stepIndex(steps, stepId) + 1;
}

export function lastStepId(steps: WizardStep[]): number {
  return steps[steps.length - 1]?.num ?? 1;
}

export function nextStepId(steps: WizardStep[], current: number): number {
  return steps.find((step) => step.num > current)?.num ?? lastStepId(steps);
}

export function prevStepId(steps: WizardStep[], current: number): number {
  const earlier = steps.filter((step) => step.num < current);
  return earlier[earlier.length - 1]?.num ?? steps[0]?.num ?? 1;
}

// Maps a requested step id (from ?step or a restored draft) onto a visible
// one. A hidden step falls back to the nearest earlier visible step, so it
// never lands the user past steps they haven't validated.
export function resolveVisibleStep(steps: WizardStep[], requested: number): number {
  if (stepIndex(steps, requested) >= 0) return requested;
  return prevStepId(steps, requested);
}
